<script setup>
  import { ref, computed, onBeforeMount } from "vue";

  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useAgentsStore } from "@/stores/agents";

  const uiStore = useUiStore();
  const agentsStore = useAgentsStore();
  const emit = defineEmits(['refresh', 'refreshSitesArr']);
  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);

  let id = ref(null);
  let name = ref(null);
  let description = ref(null);
  let isSubmitted = ref(false);

  const onSubmit = async () => {
    isSubmitted.value = true;
    
    const data = { 
      agent_id : id.value, 
      name: name.value,
      description: description.value,
      company_id 
    };
    agentsStore.duplicateAgent(data).then(() => {
      resetStoreData();
      emit('refresh');
    }).catch(() => {});
  }

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalAction.value == 'duplicate_agent'){

      id.value = getModalInfo.value.id;
    }

  });

</script>
<template>
  <DModal v-if="getModalAction === 'duplicate_agent'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Duplicate Agent </template>
    
    <template #body>
        
      <div class="mb-3">
        <DInput :value="name" @input="name = $event.target.value" label="Agent Name" width="100%" />
      </div>

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="agentDescription"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="agentDescription">Description</label>
      </FloatLabel>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!name || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Duplicate
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>

  </DModal>
</template>
